import { CREDIT_POLICY_COPY_V2, insufficientCreditsCopy, isLowBalance } from '@rehub/pricing';

export function LowCreditsBanner({
  balance,
  needed,
  monthlyAllowance,
  onBuy,
  onUpgrade,
}: {
  balance: number;
  needed?: number;
  monthlyAllowance?: number | null;
  onBuy: () => void;
  onUpgrade?: () => void;
}) {
  if (needed != null && balance < needed) {
    const copy = insufficientCreditsCopy(needed, balance);
    return (
      <div className="rounded-xl border border-amber-700/40 bg-amber-950/40 p-4 text-sm text-amber-50">
        <p className="font-semibold">{copy.title}</p>
        <p className="text-amber-100/80">{copy.balanceLabel}</p>
        <div className="mt-3 flex flex-wrap gap-2">
          <button type="button" onClick={onBuy} className="rounded-lg bg-amber-500 px-3 py-1.5 font-semibold text-slate-950">
            {CREDIT_POLICY_COPY_V2.buyCredits}
          </button>
          {onUpgrade && (
            <button type="button" onClick={onUpgrade} className="rounded-lg border border-amber-400/40 px-3 py-1.5 font-semibold">
              {CREDIT_POLICY_COPY_V2.upgradePlan}
            </button>
          )}
        </div>
      </div>
    );
  }

  if (!isLowBalance(balance, monthlyAllowance)) return null;

  return (
    <div className="rounded-xl border border-amber-700/40 bg-amber-950/40 p-4 text-sm text-amber-50">
      <p className="font-semibold">{CREDIT_POLICY_COPY_V2.lowBalance}</p>
      <p className="text-amber-100/80">Current balance: {balance} credits</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <button type="button" onClick={onBuy} className="rounded-lg bg-amber-500 px-3 py-1.5 font-semibold text-slate-950">
          {CREDIT_POLICY_COPY_V2.buyCredits}
        </button>
        {onUpgrade && (
          <button type="button" onClick={onUpgrade} className="rounded-lg border border-amber-400/40 px-3 py-1.5 font-semibold">
            {CREDIT_POLICY_COPY_V2.upgradePlan}
          </button>
        )}
      </div>
    </div>
  );
}
